export default "__VITE_ASSET__Dps_jcGb__"